module.exports = __webpack_public_path__ + "img/83.2d6a25ee.jpg";